import { useIssueReports } from "../../../../hooks/useIssueReports"
import { IssueReportGet } from "../../../models/IssueReport"
import {
  dateStringComparator,
  getNiceFormattedDate,
} from "../../../utils/getFormattedDate"
import { EntityTab } from "../../partials/EntityTab"

export function IssueReports() {
  const { issueReportsList, isLoadingIssueReports } = useIssueReports()

  const cols = [
    {
      field: "username",
      headerName: "Username",
      isLink: true,
      linkBasePath: "/issue-reports",
    },
    { field: "applicationShortName", headerName: "Application" },
    { field: "topic", headerName: "Topic" },
    {
      field: "creationDate",
      headerName: "Creation date",
      sortComparator: dateStringComparator,
    },
  ]

  const sorted = [...issueReportsList].sort(
    (a, b) =>
      new Date(b.creationDate ?? 0).getTime() - new Date(a.creationDate ?? 0).getTime()
  )

  const rows = sorted.map((issueReport: IssueReportGet) => ({
    id: issueReport.id,
    username: issueReport.userEmail,
    applicationShortName: issueReport.application.shortName,
    topic: issueReport.topic.name,
    description: issueReport.message,
    creationDate: getNiceFormattedDate(issueReport.creationDate),
  }))

  return <EntityTab rows={rows} cols={cols} isLoading={isLoadingIssueReports} />
}
